import { Step, TeacherStep, TeacherStepR } from "../../../../shared/models/step/step.model";

export const STEP_FEATURE_KEY = 'STEP';

export interface State{
    loaded:boolean;
    error?:string | null;
    data: TeacherStep[] | Step| number|null | TeacherStepR[];
}